// extracted by mini-css-extract-plugin
module.exports = {"recipe":"recipe_recipe__jVGQB","image":"recipe_image__2lHrd","para":"recipe_para__36XSI","App":"recipe_App__3zqJ-"};